import PropTypes from "prop-types";
import React, { useState } from "react";
import { Row, Col, Alert, Card, CardBody, Container, FormFeedback, Input, Label, Form, Button } from "reactstrap";
import withRouter from "components/Common/withRouter";
import UserService from "Api/Services/UserService";
import Spinners from "components/Common/Spinner";
import PageTitle from "../../components/Common/PageTitle";

const ChangePassword = props => {
    document.title = "Change Password | Infuse One";
    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState('');
    const [currentpwdError, setCurrentpwdError] = useState('');
    const [success, setSuccess] = useState('');
    const [isLoading, setLoading] = useState(false);
    const [currenthideshowPassword, setCurrenthideshowPassword] = useState(false);
    const [newhideshowPassword, setNewhideshowPassword] = useState(false);
    const [confirmhideshowPassword, setconfirmhideshowPassword] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();

        setLoading(true);
        const userData = {
            current_password: e.target.current_password.value,
            new_password: e.target.newPassword.value,
            confirm_password: e.target.confirmPassword.value
        };
        try {
            const response = await UserService.UserchangePassword(userData).json();
            if (response.status === true) {
                setError('');
                setCurrentpwdError('');
                setSuccess(response.message);
                setLoading(false);

            } else {
                setSuccess('');
                setLoading(false);
                setError(response.errors);
                setCurrentpwdError(response.message);
                return;
            }
        } catch (error) {
            setError('something went wrong');
            return;
        }
    };
    const previewcurrentPassword = () => {
        // setCurrentPassword(!currentPassword);
        setCurrenthideshowPassword(!currenthideshowPassword)

    };
    const previewnewPassword = () => {
        setNewhideshowPassword(!newhideshowPassword)
    };
    const previewconfirmPassword = () => {
        setconfirmhideshowPassword(!confirmhideshowPassword)
    };


    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <div className="container-fluid">
                        <PageTitle title="Change Password" />
                        {isLoading ? <Spinners setLoading={setLoading} /> : (
                            <Row>
                                <Col lg={12}>
                                    <Card>
                                        <CardBody>
                                            {/* Alert Messages */}
                                            {success && success.trim() !== "" ? (
                                                <Alert color="success" className="mb-4">
                                                    {success}
                                                </Alert>
                                            ) : (
                                                !error?.current_password && currentpwdError && (
                                                    <Alert color="danger" className="mb-4">
                                                        {currentpwdError}
                                                    </Alert>
                                                )
                                            )}

                                            {/* Password Form */}
                                            <Form onSubmit={handleSubmit} className="form-horizontal">
                                                <Row>
                                                    <Col md={6}>
                                                        <div className="mb-3">
                                                            <Label className="form-label">Current Password <i className="mdi mdi-asterisk text-danger"></i></Label>
                                                            <div className="d-flex gap-2">
                                                                <Input
                                                                    type={currenthideshowPassword ? 'text' : 'password'}
                                                                    name="current_password"
                                                                    className="form-control"
                                                                    placeholder="Enter Current Password"
                                                                    onChange={(e) => setCurrentPassword(e.target.value)}
                                                                    style={{ height: '38px', fontSize: '14px' }}
                                                                />
                                                                <Button 
                                                                    type="button" 
                                                                    color="light" 
                                                                    onClick={previewcurrentPassword} 
                                                                    title={currenthideshowPassword ? 'Hide' : 'Show'}
                                                                    style={{ height: '38px', width: '38px', padding: '0' }}
                                                                >
                                                                    <i className={currenthideshowPassword ? 'bx bx-show' : 'bx bx-hide'}></i>
                                                                </Button>
                                                            </div>
                                                            {error?.current_password && (
                                                                <FormFeedback type="invalid" style={{ display: 'block' }}>{error.current_password[0]}</FormFeedback>
                                                            )}
                                                        </div>
                                                    </Col>
                                                </Row>

                                                <Row>
                                                    <Col md={6}>
                                                        <div className="mb-3">
                                                            <Label className="form-label">New Password <i className="mdi mdi-asterisk text-danger"></i></Label>
                                                            <div className="d-flex gap-2">
                                                                <Input
                                                                    type={newhideshowPassword ? 'text' : 'password'}
                                                                    name="newPassword"
                                                                    className="form-control"
                                                                    placeholder="Enter New Password"
                                                                    onChange={(e) => setNewPassword(e.target.value)}
                                                                    style={{ height: '38px', fontSize: '14px' }}
                                                                />
                                                                <Button 
                                                                    type="button" 
                                                                    color="light" 
                                                                    onClick={previewnewPassword} 
                                                                    title={newhideshowPassword ? 'Hide' : 'Show'}
                                                                    style={{ height: '38px', width: '38px', padding: '0' }}
                                                                >
                                                                    <i className={newhideshowPassword ? 'bx bx-show' : 'bx bx-hide'}></i>
                                                                </Button>
                                                            </div>
                                                            {error?.new_password && (
                                                                <FormFeedback type="invalid" style={{ display: 'block' }}>{error.new_password[0]}</FormFeedback>
                                                            )}
                                                        </div>
                                                    </Col>
                                                </Row>

                                                <Row>
                                                    <Col md={6}>
                                                        <div className="mb-4">
                                                            <Label className="form-label">Confirm Password <i className="mdi mdi-asterisk text-danger"></i></Label>
                                                            <div className="d-flex gap-2">
                                                                <Input
                                                                    type={confirmhideshowPassword ? 'text' : 'password'}
                                                                    name="confirmPassword"
                                                                    className="form-control"
                                                                    placeholder="Enter Confirm Password"
                                                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                                                    style={{ height: '38px', fontSize: '14px' }}
                                                                />
                                                                <Button 
                                                                    type="button" 
                                                                    color="light" 
                                                                    onClick={previewconfirmPassword} 
                                                                    title={confirmhideshowPassword ? 'Hide' : 'Show'}
                                                                    style={{ height: '38px', width: '38px', padding: '0' }}
                                                                >
                                                                    <i className={confirmhideshowPassword ? 'bx bx-show' : 'bx bx-hide'}></i>
                                                                </Button>
                                                            </div>
                                                            {error?.confirm_password && (
                                                                <FormFeedback type="invalid" style={{ display: 'block' }}>{error.confirm_password[0]}</FormFeedback>
                                                            )}
                                                        </div>
                                                    </Col>
                                                </Row>

                                                <div>
                                                    <Button type="submit" color="primary" style={{ fontSize: '14px' }}>
                                                        Change Password
                                                    </Button>
                                                </div>
                                            </Form>
                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>
                        )}
                    </div>
                </Container>
            </div>
        </React.Fragment>
    );
};

ChangePassword.propTypes = {
    history: PropTypes.object,
};

export default withRouter(ChangePassword);
